import React, { useState } from 'react';
import {
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverBody,
  Button,
  Box,
  VStack,
  Text,
  useDisclosure
} from '@chakra-ui/react';
import { ChevronDownIcon } from '@chakra-ui/icons';

const intervals = ['minutes', 'hours', 'days', 'weeks', 'months', 'years'];

export const RepeatIntervalSelect = ({ value, onChange }) => {
  const { isOpen, onOpen, onClose } = useDisclosure();

  const handleSelect = (interval) => {
    onChange(interval);
    onClose();
  };

  return (
    <Popover isOpen={isOpen} onClose={onClose} onOpen={onOpen} placement="bottom-start">
      <PopoverTrigger>
        <Button
          variant="outline"
          size="sm"
          w="100px"
          justifyContent="space-between"
          rightIcon={<ChevronDownIcon fontSize="sm" />}
        >
          <Text fontSize="xs">{value || "minutes"}</Text>
        </Button>
      </PopoverTrigger>

      <PopoverContent w="120px" borderColor="gray.200" boxShadow="md">
        <PopoverBody p={0}>
          <VStack align="stretch" spacing={0}>
            {intervals.map((interval) => (
              <Box
                key={interval}
                px={3}
                py={2}
                fontSize="xs"
                cursor="pointer"
                bg={value === interval ? 'blue.50' : 'white'}
                color={value === interval ? 'blue.600' : 'gray.800'}
                fontWeight={value === interval ? 'medium' : 'normal'}
                _hover={{ bg: 'gray.50' }}
                onClick={() => handleSelect(interval)}
              >
                {interval}
              </Box>
            ))}
          </VStack>
        </PopoverBody>
      </PopoverContent>
    </Popover>
  );
};
